import React from 'react'

const HeroView = ({ message }) => {
  return <section className="hero is-dark page-header-section">
           <div className="hero-body">
             <div className="columns">
               <div className="column is-4 results-heading">
                 <div className="page-headline" role="heading" aria-level="1">Your Lists</div>
               </div>
               <div className="column is-8">{ message }</div>
             </div>
           </div>
         </section>
}

export default HeroView